<table class="w-100 attachments" *ngIf="attachments.length > 0">
  <tr *ngFor="let attachment of attachments">
    <td class="align-middle attachment">
      <a class="link" (click)="onDownload(attachment.fileId)">{{ attachment.name }}</a>
    </td>
  </tr>
</table>
